export enum ConnectorButtonsEnum {
  ACCOUNT = 'Account',
  PERSONAL_DATA = 'Personal data',
  SECURITY_SETTINGS = 'Security settings',
  PAYMENT_INFORMATION = 'Payment information',
  LOGOUT = 'Logout'
}